import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, UntypedFormControl } from '@angular/forms';

@Component({
  selector: '[pgh-input-error]',
  template: '<span *ngIf="control.invalid && control.dirty"> {{ error }}</span>'
})
export class InputErrorComponent implements OnInit {
  constructor(
    private parent: ControlContainer
  ) { }

  @Input() set errorMessages(value) {
    this._customErrorMessages = new Map(Object.entries(value));
  }
  get errorMessages() {
    return new Map([...this._defaultErrorMessages, ...this._customErrorMessages]);
  }
  @Input() set label(value: string) {
    this._defaultErrorMessages.set('required', `Enter ${value}`);
    this._defaultErrorMessages.set('invalid', `Invalid ${value}`);
  }
  @Input() controlName: string;

  get error() {
    let errorMessage = this.errorMessages.get('invalid');
    this.errorMessages.forEach((message, errorType) => {
      if (this.control.getError(errorType)) {
        errorMessage = message;
        return;
      }
    });

    return errorMessage;
  }

  control: UntypedFormControl;
  private _customErrorMessages: Map<string, string> = new Map();
  private _defaultErrorMessages: Map<string, string> = new Map([
    ['required', 'Enter Value'],
    ['invalid', 'Invalid Value']
  ]);

  ngOnInit() {
    if (this.parent) {
      this.control = <UntypedFormControl> this.parent?.control?.get(this.controlName);
    }

    if (!this.control) {
      throw new Error('A valid control is required for InputErrorComponent');
    }
  }
}
